import { useEffect, useRef, useState } from "react";
import api, { mediaUrl } from "@/lib/api";

function EmbedAd({ code, position }) {
  const ref = useRef(null);
  useEffect(() => {
    const container = ref.current;
    if (!container || !code) return;
    container.innerHTML = code;
    // Re-inject scripts so ad-network JS actually executes (innerHTML doesn't run them).
    const scripts = Array.from(container.querySelectorAll("script"));
    scripts.forEach((old) => {
      const s = document.createElement("script");
      Array.from(old.attributes).forEach((attr) => s.setAttribute(attr.name, attr.value));
      s.text = old.text;
      old.parentNode.replaceChild(s, old);
    });
  }, [code]);
  return <div ref={ref} data-testid={`ad-embed-${position}`} className="w-full flex justify-center overflow-hidden" />;
}

export default function AdSlot({ position, className = "" }) {
  const [ads, setAds] = useState([]);
  useEffect(() => {
    api.get(`/ads?position=${encodeURIComponent(position)}`).then((r) => setAds(r.data || [])).catch(() => {});
  }, [position]);
  if (!ads.length) return null;
  const ad = ads[0];
  const isEmbed = ad.ad_type === "embed" && ad.embed_code;
  return (
    <div data-testid={`ad-slot-${position}`} className={`flex justify-center ${className}`}>
      {isEmbed ? (
        <EmbedAd code={ad.embed_code} position={position} />
      ) : (
        <a href={ad.url || "#"} target="_blank" rel="noopener noreferrer" className="block max-w-full" data-testid={`ad-link-${position}`}>
          {ad.image ? (
            <img src={mediaUrl(ad.image)} alt={ad.name} className="max-w-full h-auto" />
          ) : (
            <div className="bg-sunset-border/60 text-sunset-muted kicker py-8 px-16 text-center">Publicidad</div>
          )}
        </a>
      )}
    </div>
  );
}
